import type { Eip1193Provider } from "ethers";
import { BaseWalletAdapter } from "./BaseWalletAdapter";

export class MetaMaskAdapter extends BaseWalletAdapter {
  readonly name = "metamask";

  get installed(): boolean {
    return Boolean(this.resolveProvider());
  }

  protected resolveProvider(): Eip1193Provider | undefined {
    if (typeof window === "undefined") return undefined;
    const ethereum = (window as any).ethereum;
    if (!ethereum) return undefined;
    // Multiple extensions: search the providers array for the real MetaMask
    if (ethereum.providers?.length) {
      const found = ethereum.providers.find(
        (p: any) => p?.isMetaMask && !p?.isRabby && !p?.isBraveWallet,
      );
      if (found) return found;
    }
    // window.ethereum is MetaMask directly (no other extensions)
    if (ethereum.isMetaMask && !ethereum.isRabby && !ethereum.isBraveWallet) {
      return ethereum;
    }
    // Last resort: MetaMask always exposes window.ethereum._metamask — no other wallet does
    if (ethereum._metamask) return ethereum;
    return undefined;
  }
}
